import { z } from "zod";
import { sessionStore } from "../../../lib/store";

/**
 * The uid of the account created in THIS session, or null.
 *
 * `sessionStorage`, so it survives the reloads of a signup but not the next
 * launch of the app, and never reaches another device. That boundary is what
 * "the signup session" means to `useHomeSurface`: a member of Juisci rooms only
 * stays in their room for it, and lands on JuisciGPT from the next session on.
 * Keyed by uid so an account switch in the same tab does not inherit it.
 */
export const signupSessionUidStore = sessionStore<string | null>(
  "signup-session-uid",
  null,
  z.string().nullable()
);
